<template>
  <button
    v-if="buttonType == 'success'"
    class="button button--success"
    :class="[props.rounded ? 'rounded' : '', props.roundedSm ? 'rounded--sm' : '', props.elevated ? props.elevated : '', props.selected ? 'selected' : '', props.fullwidth ? 'fullwidth' : '', props.iconName ? 'has-icon' : '', props.loading ? 'loading' : '', props.classes, useDisabledStyle ? 'disabled' : '']"
    :disabled="props.disabled"
    :style="{ 'font-size': props.fontSize + ' !important', 'padding': props.padding + ' !important' }"
    @click="emit('event:buttonPress')"
    :form="props.form"
  >
    <Icon v-if="props.iconName" :icon-name="props.iconName" :icon-size="props.iconSize" />
    <svg v-if="props.loading" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48" fill="#ffffff" class="icon loading" style="margin: 0 auto;"><path d="M189.308-186.154v-30.769h133.076l-41.922-40.461q-51.693-47.924-76.077-102.154Q180-413.769 180-476.231q0-93.692 52.885-170.884 52.884-77.193 141.038-112.27v32q-74.231 32.847-118.692 101.116Q210.769-558 210.769-476.231q0 57.616 21.577 105.269 21.577 47.654 62.346 85.5l50 46.385v-133.231h30.77v186.154H189.308Zm397-14.23v-32.231q75.23-32.847 119.077-101.116Q749.231-402 749.231-483.769q0-50.308-21.577-99.808-21.577-49.5-61.116-89.038l-49.769-48.308v133.231H586v-186.154h186.154v30.769H638.846L680-701.385q50.769 49.077 75.385 105.77Q780-538.923 780-483.769q0 93.692-52.769 171T586.308-200.384Z"/></svg>
    <span v-if="!props.loading">{{ props.buttonText }}</span>
  </button>

  <button
    v-if="buttonType == 'ghostly-success'"
    class="text-base flex flex-row gap-4 items-center font-normal text-center text-quartz bg-white rounded-full py-3 px-3 hover:bg-slate-50 active:bg-white hover:opacity-80 focus:outline-none focus:ring-1 focus:ring-quartz border border-quartz max-xl:text-campaya-primary max-xl:border-none max-xl:bg-bg-btn-mobile"
    @click="emit('event:buttonPress')"
  >
    {{ props.buttonText }}
  </button>




  <button
    v-if="buttonType == 'secondary'"
    class="button button--secondary"
    :class="[props.rounded ? 'rounded' : '', props.roundedSm ? 'rounded--sm' : '', props.elevated ? props.elevated : '', props.selected ? 'selected' : '', props.fullwidth ? 'fullwidth' : '', props.iconName ? 'has-icon' : '', props.loading ? 'loading' : '', props.classes, useDisabledStyle ? 'disabled' : '']"
    :style="{ 'font-size': props.fontSize }"
    @click="emit('event:buttonPress')"
  >
    <Icon v-if="props.iconName" :icon-name="props.iconName" :icon-size="props.iconSize" />
    <Icon v-if="props.loading" icon-name="sync_200" :size="props.iconSize" class="icon loading" />
    <span v-if="!props.loading">{{ props.buttonText }}</span>
  </button>



  <button
    v-if="buttonType == 'danger'"
    class="button button--danger"
    :class="[props.rounded ? 'rounded' : '', props.roundedSm ? 'rounded--sm' : '', props.elevated ? props.elevated : '', props.selected ? 'selected' : '', props.fullwidth ? 'fullwidth' : '', props.iconName ? 'has-icon' : '', props.loading ? 'loading' : '', props.classes, useDisabledStyle ? 'disabled' : '']"
    @click="emit('event:buttonPress')"
  >
    <Icon v-if="props.iconName" :icon-name="props.iconName" :icon-size="props.iconSize" />
    <Icon v-if="props.loading" icon-name="sync_white_200" :size="props.iconSize" class="icon loading" />
    <span v-if="!props.loading">{{ props.buttonText }}</span>
  </button>



  <button
    v-if="buttonType == 'link'"
    class="button button--link"
    :class="[props.rounded ? 'rounded' : '', props.roundedSm ? 'rounded--sm' : '', props.elevated ? props.elevated : '', props.selected ? 'selected' : '', props.bold ? 'font-bold' : '', props.fullwidth ? 'fullwidth' : '', props.iconName ? 'has-icon' : '', props.loading ? 'loading' : '', props.classes, useDisabledStyle ? 'disabled' : '']"
    :style="{ 'font-size': props.fontSize }"
    @click="emit('event:buttonPress')"
  >
    <Icon v-if="props.iconName" :icon-name="props.iconName" :icon-size="props.iconSize" />
    <Icon v-if="props.loading" icon-name="sync_200" :size="props.iconSize" class="icon loading" />
    <span v-if="!props.loading">{{ props.buttonText }}</span>
  </button>



  <button
    v-if="buttonType == 'bordered'"
    class="button button--bordered"
    :class="[props.rounded ? 'rounded' : '', props.roundedSm ? 'rounded--sm' : '', props.elevated ? props.elevated : '', props.selected ? 'selected' : '', props.bold ? 'font-bold' : '', props.fullwidth ? 'fullwidth' : '', props.iconName ? 'has-icon' : '', props.loading ? 'loading' : '', props.classes, useDisabledStyle ? 'disabled' : '']"
    :style="{ 'font-size': props.fontSize }"
    @click="emit('event:buttonPress')"
  >
    <Icon v-if="props.iconName" :icon-name="props.iconName" :size="props.iconSize" class="icon" />
    <Icon v-if="props.loading" icon-name="sync_200" :size="props.iconSize" class="icon loading" />
    <span v-if="!props.loading">{{ props.buttonText }}</span>
  </button>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import Icon from '../Icon/Icon.vue'
  const emit = defineEmits(["event:buttonPress"]);
  const props = defineProps({
    buttonText: { type: String },
    rounded: { type: Boolean },
    buttonStyle: { type: String },
    elevated: { type: String },
    selected: { type: Boolean },
    fontSize: { type: String },
    bold: { type: Boolean },
    padding: { type: String },
    iconName: { type: String },
    iconSize: { type: String },
    fullwidth: { type: Boolean },
    loading: { type: Boolean },
    classes: { type: String },
    disabled: { type: Boolean, default: false },
    form: { type: String },
    useDisabledStyle: { type: Boolean, default: false },
    roundedSm: { type: Boolean, default: false }
  });

  /**
   * Return success button if the style has been set to success or it if hasn't been set at all
   */
  const buttonType = computed(() => {
    if (props.buttonStyle == 'success' || typeof props.buttonStyle == "undefined") return 'success'
    else return props.buttonStyle
  })

</script>





<style scoped src="./../../../styles/components/_button.scss" lang="scss"></style>
